import { User } from "firebase/auth";
import { createContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getInInUser } from "components/User";
import { useQuery, useQueryClient } from "react-query";

const auth = getAuth();

export type InInUser = {
  creationTime: User['metadata']['creationTime'],
  lastSignInTime: User['metadata']['lastSignInTime'],
  opinionLikes: string[],
  opinionReports: string[],
  canReadArticles: boolean,
  canReadReason: string | null,
  photoURL: string;
} & Pick<User, 'uid' | 'email' | 'emailVerified' | 'displayName' | 'phoneNumber'>;

type UserContextType = {
  user: InInUser | null;
  isLoading: boolean;
}

export const UserContext = createContext<UserContextType>({ user: null, isLoading: true });
export const useUserContext = () => {
  const queryClient = useQueryClient();
  const [isInitialized, setIsInitialized] = useState(false);
  const { isLoading, isFetching, isRefetching, data: user = null } = useQuery(['me'], async () => {
    if (!auth.currentUser) {
      return null;
    }

    return await getInInUser(auth.currentUser.uid);
  })

  useEffect(() => {
    onAuthStateChanged(auth, async (authUser) => {
      setIsInitialized(true);
      queryClient.invalidateQueries('me');
    });
  }, [queryClient]);

  return {
    isLoading: !isInitialized || isLoading || isFetching || isRefetching,
    user,
  };
}